import { ActivityType } from '@apeiron/common'
import { ROUTE } from '@src/constants/route'

export enum ActivityRoute {
  Apostle = ROUTE.OTHER_INVENTORY_APOSTLE_LIST,
  Planet = ROUTE.OTHER_INVENTORY_PLANET_LIST,
  Star = ROUTE.OTHER_INVENTORY_STAR_LIST
}

// filter for PlanetActivityType for sale history
export const PLANET_SALE_HISTORIES_FILTER = [ActivityType.Buy]

export const STAR_SALE_HISTORIES_FILTER = [ActivityType.Buy]

export const ASTRONOMICAL_SALE_HISTORIES_FILTER = [ActivityType.Buy]

export const APOSTLE_SALE_HISTORIES_FILTER = [
  ActivityType.Buy,
  ActivityType.ApostleBounty
]

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
